type IconProps = React.SVGProps<SVGSVGElement>;

const BackIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 14 12"
      fill="none"
    >
      <path
        d="M13.1875 6H0.8125M0.8125 6L5.875 0.9375M0.8125 6L5.875 11.0625"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default BackIcon;
